<template>
  <div>
    <!-- {{ data }} -->
    <JobDetails
      :data="data.details"
      :domains="data.domains"
      :contract_types="data.contract_types"
      :presence="data.presence"
      :visas="data.visas"
      :recruiters="data.recruiters"
      :salary="data.salary"
      :metadata="data.metadata"
      :drivers_licenses="data.drivers_licenses"
      :errors="errors"
      :is-job-template="isJobTemplate"
      @jobDataEmitUpdate="handleJobDataEmitUpdate"
    />

    <Requisition
      v-if="data.requisition"
      :data="data.requisition"
      :errors="errors"
      :is-job-template="isJobTemplate"
    />

    <Location
      v-model:data="data.locations"
      :job="data.details"
      :errors="errors"
      :is-job-template="isJobTemplate"
    />

    <JobDescription
      :data="data.details"
      :errors="errors"
      :is-job-template="isJobTemplate"
    />
    <JobInclusivity
      :data="data.inclusivity"
      :job="data.details"
      :is-job-template="isJobTemplate"
    />

    <Skills
      :data="data.skills"
      :errors="errors"
      :is-job-template="isJobTemplate"
    />

    <div class="md:grid md:grid-cols-2 md:gap-x-10">
      <Values :data="data.values" :is-job-template="isJobTemplate" />
      <Perks :data="data.perks" :is-job-template="isJobTemplate" />
    </div>

    <Languages
      :data="data.languages"
      :errors="errors"
      :is-job-template="isJobTemplate"
    />

    <RecruitmentProcess
      :data="data.recruitment_process"
      :errors="errors"
      :is-job-template="isJobTemplate"
    />

    <AtsProcess
      :data="data.ats_recruitment_process"
      :errors="errors"
      :is-job-template="isJobTemplate"
    />
  </div>
</template>

<script setup>
  import { reactive } from 'vue';

  import {
    Values,
    Perks,
    JobDescription,
    Skills,
    Languages,
    JobInclusivity,
    AtsProcess,
    RecruitmentProcess,
    JobDetails,
    Location,
    Requisition
  } from '.';

  const props = defineProps({
    name: String,
    data: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true
    },
    isJobTemplate: {
      type: Boolean,
      default: false
    }
  });

  const data = reactive(props.data);

  function handleJobDataEmitUpdate(newData) {
    Object.assign(data, newData.data);
  }
</script>
